/**
 * 런처 `+` 버튼으로 수집한 id 를 FeedbackChat 이 마운트되기 전까지 보관하는 버퍼.
 *
 * 흐름: 런처 `+` → DevIdInspector capture-once → 'dev-id-inspector:captured' 이벤트
 *   - 패널이 expanded 상태면 FeedbackChat 리스너가 직접 textarea 에 삽입 (버퍼 미사용)
 *   - 패널이 closed/minimized 면 FeedbackChat 이 아직 없음 → 런처가 여기 push 하고 패널을 펼침
 *   - FeedbackChat 마운트 시 drain 해서 textarea 에 삽입
 */
const pending: string[] = [];

export const pushPendingCapturedId = (id: string): void => {
  if (!id) return;
  if (pending.includes(id)) return;
  pending.push(id);
};

export const drainPendingCapturedIds = (): string[] => pending.splice(0, pending.length);
